import React from "react";
import {auth} from "../../../firebase";
import {selectAuthstate, selectEmail} from "../../../slices/auth";
import {useDispatch, useSelector} from "react-redux";
import {openAlert} from "../../../slices/alert";
import {openDialog} from "../../../slices/dialog";
import Button from "../../../components/Common/Button";
import ChangeEmail from "../../../components/Dialog/ChangeEmail";
import "./style.scss";
import {StudentSettingsName} from "./components/StudentSettingsName";
import {StudentSettingsPhone} from "./components/StudentSettingsPhone";
import {useTranslation} from "react-i18next";

const StudentSettings = () => {
    const dispatch = useDispatch();
    const account = useSelector(selectAuthstate);
    const email = useSelector(selectEmail);
    const {t} = useTranslation();

    const onVerifyAccount = () => {
        const currentUser = auth.currentUser;
        if (currentUser)
            currentUser
                .sendEmailVerification()
                .then(() => {
                    dispatch(openAlert({type: "success", message: t("alert_email_sent")}));
                })
                .catch((error) => {
                    dispatch(openAlert({type: "error", message: t("alert_generic_error")}));
                });
    };

    const onChangeEmail = () => {
        dispatch(
            openDialog({
                Content: ChangeEmail,
                title: t("account_changeEmail_title"),
                closable: true,
            })
        );
    };

    // useEffect(() => {
    // 	navigator.serviceWorker.addEventListener("message", (message) =>
    // 		console.log(message)
    // 	);
    // }, []);

    return (
        <div className="studentSettings">
            <h2 className="title mb30">{t("student_settings_title")}</h2>

            <StudentSettingsName/>
            <StudentSettingsPhone/>

            <div className="studentSettings__email">
                <label className="label">{t("student_settings_email")}</label>
                <p className="body">{email}</p>
                {!account?.verified && (
                    <div className="verifyButton">
                        <Button onClick={() => onVerifyAccount()}>{t("student_settings_verifyEmail")}</Button>
                    </div>
                )}
                <Button onClick={() => onChangeEmail()}>{t("student_settings_changeEmailBtn")}</Button>
            </div>
        </div>
    );
};

export default StudentSettings;
